import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";



export const fun1 = async (logindata) => {
    try {
        const axiosRes = await axios({
            method: "POST",
            url: `${API_BASE_URL}/api/users/login`,
            data: logindata,
        });
        console.log("login [SUCCESS]", axiosRes.data);
        return axiosRes?.data;
    } catch (err) {
        console.log("login [ERROR]", err);
        return err;
    }
}

export const fun2 = async (signupData) => {
    try {
        const axiosRes = await axios({
            method: "POST",
            url: `${API_BASE_URL}/api/users/signup`,
            data: signupData,
        });
        console.log("register [SUCCESS]", axiosRes.data);
        return axiosRes?.data;
    } catch (err) {
        console.log("login [ERROR]", err);
        return err;
    }
}
